import AdminApi from '../services/api';
import swal from 'sweetalert2';

/* init */

const AdminApiService = new AdminApi()

export default{

    props: ['show'],

    data() {
        return {
            title: '',
            isLoading: false,
            name: '',
            surname: '',
            username: '',
            password: '',
            hasError: ''
        };
    },

    watch: {
        show: function(val, oldVal) {

        },
        username: function(val, oldVal) {
            this.hasError = '';
        },
        password: function(val, oldVal) {
            this.hasError = '';
        },
        name: function(val, oldVal) {
            this.hasError = '';
        },
        surname: function(val, oldVal) {
            this.hasError = '';
        }
    },

    methods: {
        close() {
            this.$topnavbar.$emit('closeAddDispatcher')
            this.reset();
        },
        successUpdate(){
            this.$topnavbar.$emit('successAddDispatcher')
        },

        addUser: addUser,
        reset: reset,
    }
}

function addUser() {
    if(this.username.length === 0 ||
        this.password.length === 0 ||
        this.surname.length === 0 ||
        this.name.length === 0
    ) {
        this.hasError = "Molimo popunite sva polja";
        return;
    }
    let _self = this;
    const newModel = {
        username: _self.username,
        password: _self.password,
        firstName: _self.name,
        lastName: _self.surname
    };
    _self.isLoading = true;
    AdminApiService.createDispatcher(newModel)
        .then((response) => {
            _self.reset();
            _self.isLoading = false;
            _self.successUpdate();
        })
        .catch((error) => {
            _self.reset();
            _self.isLoading = false;
            _self.hasError = "Greška prilikom dodavanja."
        })

}

function reset() {
    this.username = '';
    this.password = '';
    this.name = '';
    this.surname = '';
}



// WEBPACK FOOTER //
// ./src/modals/AddDispatcherModal.js